module.exports = kolibriCoreAppGlobal.coreVue.components.PasswordTextbox;